import { apiClient } from './client';
import type { ListaEmpleadosResp, EmpleadoDetalle, CarnetEmpleado } from '@/types/dominio';

export interface ListEmpleadosParams {
  busqueda?: string;
  activo?: boolean;
  page?: number;
  pageSize?: number;
}

export async function getEmpleados(params: ListEmpleadosParams = {}): Promise<ListaEmpleadosResp> {
  // `activo` se envía como string ('true'/'false') porque el backend lo valida con IsBooleanString.
  const query: Record<string, string | number | undefined> = {
    busqueda: params.busqueda,
    page: params.page,
    pageSize: params.pageSize,
    activo: params.activo === undefined ? undefined : String(params.activo),
  };
  const { data } = await apiClient.get<ListaEmpleadosResp>('/empleados', { params: query });
  return data;
}

export async function getEmpleadoDetalle(id: string): Promise<EmpleadoDetalle> {
  const { data } = await apiClient.get<EmpleadoDetalle>(`/empleados/${id}`);
  return data;
}

export async function getCarnetEmpleado(id: string): Promise<CarnetEmpleado> {
  const { data } = await apiClient.get<CarnetEmpleado>(`/empleados/${id}/carnet`);
  return data;
}
